import React from 'react';

const orders = [
  {
    id: 1,
    item: '📘 AI Trading Course',
    amount: '$99',
    status: 'Paid',
    date: 'May 20, 2025',
  },
  {
    id: 2,
    item: '📈 Gold Signals - Premium Pack',
    amount: '$39',
    status: 'Pending',
    date: 'May 22, 2025',
  },
  {
    id: 3,
    item: '💼 Freelance UX Project',
    amount: '$550',
    status: 'Completed',
    date: 'May 18, 2025',
  },
];

export default function OrderSummaryBox() {
  return (
    <div className="bg-black shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">🧾 Orders & Invoices</h3>
      <div className="space-y-3 text-sm text-gray-700">
        {orders.map((order) => (
          <div
            key={order.id}
            className={`border-l-4 p-3 rounded ${
              order.status === 'Paid'
                ? 'border-green-500 bg-green-50'
                : order.status === 'Pending'
                ? 'border-yellow-500 bg-yellow-50'
                : 'border-blue-500 bg-blue-50'
            }`}
          >
            <div className="font-semibold">{order.item}</div>
            <div className="text-xs text-gray-600">
              {order.date} • <span className="font-medium">{order.amount}</span> • {order.status}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
